'use strict';

/**
 * Use this function to confirm that a `switch` statement is exhaustive
 * @param x
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function assertUnreachable(x) {
    console.log({
        x
    });
    throw new Error("Didn't expect to get here");
}

module.exports = assertUnreachable;
